export const ordersStatusesCodes = {
    pending: "Pendiente",
    confirmed: "Confirmada",
    requested: "Solicitando unidad",
    manufactory_in_process: "Fabricación en progreso",
    in_transit: "Transito",
    completed: "Completado",
    ready_to_pickup: "Listo para recoger",
    cancelled: "Cancelada",
    start_returned: "Inicio retorno",
    returned: "Retornada",
    quote: "Cotización",
    wildcard: "No definido"
};

export const ordersStatusesMessageClass = {
    quote: "text-purple-500",
    pending: "text-theme-warning",
    confirmed: "text-theme-primary",
    requested: "text-theme-primary",
    manufactory_in_process: "text-theme-primary",
    in_transit: "text-green-500",
    ready_to_pickup: "text-green-500",
    completed: "text-theme-success",
    cancelled: "text-danger",
    start_returned: "text-danger",
    returned: "text-danger",
    wildcard: "text-yellow-600"
};

export const ordersStatuses = {
    cancelled: "cancelled",
    completed: "completed",
    quote: "quote",
    pending: "pending",
    confirmed: "confirmed",
    manufactory_in_progress: "manufactory_in_process",
    ready_to_pickup: "ready_to_pickup",
    requested: "requested",
    started_return: "started_return",
    transit: "in_transit",
    wildcard: "wildcard",
    returned: "returned"
};

export const nextOrderStatuses = {
    [ordersStatuses.quote]: ordersStatuses.pending,
    [ordersStatuses.pending]: ordersStatuses.confirmed,
    [ordersStatuses.confirmed]: ordersStatuses.ready_to_pickup,
    [ordersStatuses.manufactory_in_progress]: ordersStatuses.ready_to_pickup,
    [ordersStatuses.requested_unit]: ordersStatuses.ready_to_pickup,
    [ordersStatuses.ready_to_pickup]: ordersStatuses.transit,
    [ordersStatuses.transit]: ordersStatuses.completed,
    [ordersStatuses.completed]: null,
    [ordersStatuses.cancelled]: null,
    [ordersStatuses.wildcard]: null
};
